/* eslint-disable max-len */
var MISC_DIRECT_FLIGHT_ARROW = {
  "default": 'M37.2652 3.26517C37.4116 3.11872 37.4116 2.88128 37.2652 2.73483L34.8787 0.34835C34.7322 0.201903 34.4948 0.201903 34.3483 0.34835C34.2019 0.494796 34.2019 0.732233 34.3483 0.87868L36.4697 3L34.3483 5.12132C34.2019 5.26777 34.2019 5.5052 34.3483 5.65165C34.4948 5.7981 34.7322 5.7981 34.8787 5.65165L37.2652 3.26517ZM4 3.375H37V2.625H4V3.375Z'
};

export { MISC_DIRECT_FLIGHT_ARROW };
//# sourceMappingURL=MISC_DIRECT_FLIGHT_ARROW.js.map
